import { render, staticRenderFns } from "./CarrierRow.vue?vue&type=template&id=080be01e&scoped=true&"
import script from "./CarrierRow.vue?vue&type=script&lang=js&"
export * from "./CarrierRow.vue?vue&type=script&lang=js&"
import style0 from "./CarrierRow.vue?vue&type=style&index=0&id=080be01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080be01e",
  null
  
)

export default component.exports